var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',[_vm._v("Pagina nao encontrada!")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }